import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const CopyPageDialog: LoadableType<{
	contentId: string;
	onClose: () => Promise<any>;
	spaceKey: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CopyPageContainer" */ './CopyPageDialogContainer.tsx'
			)
		).CopyPageDialogContainer,
});
